enum OrganisationBillingType {
  LEGACY = 'legacy',
  AZURE_SAAS = 'azure-saas',
  STRIPE = 'stripe',
  DIRECT_INVOICE = 'direct-invoice',
  PARTNER_INVOICE = 'partner-invoice',
}

export default OrganisationBillingType;
